import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { ArrowRight, Menu, X } from 'lucide-react';
import './Hero.css'
import './Hero-responsive.css'
import logoImg from './logouprise.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className="header">
        <div className="header-content">

          {/* Logo */}
          <Link to="/" >
            <div className="logo">
              <img 
                src={logoImg} 
                alt="BeyondTheAnalysis Logo" 
                className="logo1-icon" 
              />
            </div>
          </Link>

          {/* Desktop / Mobile Nav */}
          <nav className={`nav ${menuOpen ? "active" : ""}`}>

            <Link 
              to="/" 
              className="nav-link" 
              onClick={() => setMenuOpen(false)}
            >
              Home
            </Link>

            <div className="nav-item dropdown">
              <span className="nav-link">Services</span>

              <div className="dropdown-menu">
                <Link 
                  to="/google-ads" 
                  className="dropdown-link" 
                  onClick={() => setMenuOpen(false)}
                >
                  Google Ads
                </Link>

                <Link 
                  to="/meta-ads" 
                  className="dropdown-link" 
                  onClick={() => setMenuOpen(false)}
                >
                  Meta Ads
                </Link>

                <Link 
                  to="/bing-ads" 
                  className="dropdown-link" 
                  onClick={() => setMenuOpen(false)}
                >
                  Bing Ads
                </Link>

                <Link 
                  to="/amazon-ads" 
                  className="dropdown-link" 
                  onClick={() => setMenuOpen(false)}
                >
                  Amazon Ads
                </Link>

                <Link 
                  to="/consultation" 
                  className="dropdown-link" 
                  onClick={() => setMenuOpen(false)}
                >
                  Free Consultation
                </Link>
              </div>
            </div>

            {/* ✅ Added Case Studies */}
            <Link 
              to="/case-study" 
              className="nav-link" 
              onClick={() => setMenuOpen(false)}
            >
              Case Studies
            </Link>

            <Link 
              to="/contact" 
              className="nav-link" 
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </Link>

            <Link 
              to="/about" 
              className="nav-link" 
              onClick={() => setMenuOpen(false)}
            >
              About Us
            </Link>

            <Link 
              to="/consultation" 
              className="nav-cta" 
              onClick={() => setMenuOpen(false)}
            >
              Book a Call
              <ArrowRight className="cta-icon" />
            </Link>

          </nav>

          {/* Mobile Toggle */}
          <button 
            className="mobile-menu" 
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>

        </div>
      </header>
    </>
  );
};

export default Navbar;